import { Routes } from '@angular/router';

import { AuthGuard } from '@core/guards/private/auth.guard';

export const PRIVATE_ROUTES: Routes = [
  {
    path: 'backoffice',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/backoffice/backoffice.routes')).BACKOFFICE_ROUTES
  },
  {
    path: 'ebi-club',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/ebi-club/ebi-club.routes')).EBI_CLUB_ROUTES
  },
  {
    path: 'tenant',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/tenant/tenant.routes')).TENANT_ROUTES,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      roles: ['TENANT', 'HOMEOWNER']
    }
  },
  {
    path: 'home-owner',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/home-owner/home-owner.routes'))
        .HOME_OWNER_ROUTES,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      roles: ['HOMEOWNER', 'TENANT']
    }
  },
  {
    // El avalista comparte pantallas con el inquilino, bajo su propio prefijo.
    path: 'guarantor',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/tenant/tenant.routes')).TENANT_ROUTES,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      roles: ['HOMEOWNER', 'TENANT']
    }
  },
  {
    // Como `backoffice`: el guard va dentro del módulo, que cuelga su propio
    // login (`/integral-renting/login`) del mismo prefijo.
    path: 'integral-renting',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/integral-renting/integral-renting.routes'))
        .INTEGRAL_RENTING_ROUTES
  },
  {
    // Como `integral-renting`: el guard (sesión + flag) va dentro del módulo.
    path: 'platform-selector',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/platform-selector/platform-selector.routes'))
        .PLATFORM_SELECTOR_ROUTES
  },
  {
    path: 'recommendation-form/:id',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/recommendation/recommendation.routes'))
        .RECOMMENDATION_ROUTES,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      roles: ['HOMEOWNER', 'TENANT']
    }
  }
];
